export default __webpack_public_path__ + "static/media/employee.11d4084b.png";